import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { SignupContext } from "../../../context/SignupContext";
import * as Yup from "yup";
import Button from "../../../components/Button";
import Loader from "../../../components/Loader";
import { confirmPasswordReset } from "firebase/auth";
import { auth } from "../../../firebase/firebase";
import APILoader from "../../../components/APILoader";

const Step3 = () => {
  const navigate = useNavigate();
  const [updatingUser, setUpdatingUser] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");

  const schema = Yup.object().shape({
    newpassword: Yup.string().required(`New Password is required!`),
    confirmpassword: Yup.string().required(`Confirm Password is required!`),
  });

  const { formData, updateFormData } = useContext(SignupContext);
  const [errors, setErrors] = useState<{ [key: string]: string | undefined }>({});

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword === ConfirmPassword) {
      setUpdatingUser(true);
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const oobCode: string | null = urlParams.get("oobCode");
        if (!oobCode) {
          console.log("No oobCode found!");
          return;
        }
        await confirmPasswordReset(auth, oobCode, newPassword);
        console.log("Password has changed successfully : " + oobCode);
        navigate("../resetsuccess");
      } catch (error) {
        console.error("Error reseting the password:", error);
        throw error;
      }
    } else {
      alert("The New and Confirmed password are not matching.");
    }
  };

  const isValid = () => {
    return Object.keys(errors).length === 0;
  };

  useEffect(() => {
    setErrors({ newpassword: "", confirmpassword: "" });
    return () => {};
  }, []);

  const onBlurMe = async (event: React.FocusEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    const isValid = await validateForm(name, value);
  };
  const validateForm = async (name: string, value: string) => {
    try {
      await schema.validateAt(name, { [name]: value });

      setErrors(prev => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
      return true;
    } catch (err) {
      let error = err as Yup.ValidationError;
      setErrors(prev => ({ ...prev, [name]: error.message }));
    }
  };

  const updateValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const newValue = { ...formData, [name]: value };
    updateFormData(newValue);
  };

  return (
    <>
      {/* {updatingUser && <Loader />} */}
      <APILoader loading={updatingUser} />
      <section>
        <div className="container">
          <div className="grid grid-cols-1 gap-3 p-5 md:grid-cols-2 gap-x-5 gap-y-5">
            {/* Left Container */}
            <div className="flex flex-col items-start justify-start">
              <h1 className="herotitle">Skarvo</h1>
              <p className="text-xl font-normal">Choose a strong password.</p>
            </div>

            {/* Right Container */}
            <div className="flex flex-col gap-10">
              <div className="flex flex-col items-start formcard">
                <div className="flex flex-row items-start formheader">
                  <div className="text-xl font-bold text-center mt-[15px] mb-[30px]">Password Reset</div>
                </div>
                <div className="mb-5 px-[30px] flex flex-col space-x-[10x] w-full">
                  <label htmlFor="newpassword" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    New Password
                  </label>
                  <input
                    type="password"
                    name="newpassword"
                    id="newpassword"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="New Password"
                    required
                    onChange={e => setNewPassword(e.target.value)}
                    onBlur={onBlurMe}
                  />
                  {errors.newpassword && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{errors.newpassword}</span>}
                  <label htmlFor="confirmpassword" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    <div className="flex justify-center w-full px-[30px] mb-[30px]"></div>
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    name="confirmpassword"
                    id="confirmpassword"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Confirm Password"
                    required
                    onChange={e => setConfirmPassword(e.target.value)}
                    onBlur={onBlurMe}
                  />
                  {errors.confirmpassword && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{errors.confirmpassword}</span>}
                </div>

                <div className="flex justify-center w-full px-[30px] mb-[30px]"></div>
                <div className="thickseparator"></div>
                <div className="flex flex-col items-center justify-between w-full p-[30px] md:flex-row-reverse  gap-y-[30px]">
                  <Button to="/verify" onClick={handleSubmit} className="w-full md:w-auto md:min-w-[120px] formprimarybutton" isDisabled={!isValid()}>
                    Reset
                  </Button>
                  <Link to="/" className="w-full md:w-auto md:min-w-[180px] formsecondarybutton">
                    Cancel
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Step3;
